import React, { useState, useEffect, useRef } from 'react';
import { loadSpecialCategory } from '../redux/actions/restaurant';
import { connect } from 'react-redux';
import { isDigitalMenu } from '../common/Functions';
import { filter } from '../redux/actions/restaurant';
import { getAvailableTags } from '../redux/reducers/restaurant';

function Filter({ filter, searchItems, loadSpecialCategory, isLoaded, availableTags, merchantId }) {

    console.log(availableTags, "availableTags");

    let [tag, setTag] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [showSearchBox, setShowSearchBox] = useState(false);
    const [activeCatId, setActiveCatId] = useState(1);
    const inputEl = useRef(null);


    function handleInputChange(value) {
        setSearchText("");
        value = value.toString();
        if (tag.indexOf(value) === -1) {

            tag.push(value);
            setTag(tag);


        } else {
            tag = tag.filter(t => t != value);
            setTag(tag);
        }

        if (tag.length == 0) {
            searchItems("");
        } else {
            filter(tag);
        }
        console.log(tag, "tagtag");
    }

    function toggle() {
        setShowSearchBox(!showSearchBox);
        setSearchText("");
        searchItems("");
        setTag([]);
        if (!showSearchBox) {
            setTimeout(() => {
                inputEl.current.focus();
            }, 100);

        }
    }

    function handleSearchChange(event) {
        setSearchText(event.target.value);
        searchItems(event.target.value)
    }

    function handleSplCatClick(catId, catName) {
        setActiveCatId(catId);
        loadSpecialCategory(catId, catName);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    useEffect(() => {
        loadSpecialCategory(1, "BESTSELLER");
    }, [isLoaded])


    const getClass = (merchantId) => {
        switch (merchantId) {
            case 1451:
                return 'filter-special-feature monginies'
                break;
            case 1664:
            case 1667:
            case 1671:
            case 1672:        
                return 'filter-special-feature monginies'    
            case 1405:
                return 'filter-special-feature global-fusion'
                break;
            default:
                return 'filter-special-feature'
                break;
        }
    }




    return (
        <>
            <div className={getClass(merchantId)}>
                <ul>
                    <li onClick={() => handleSplCatClick(1, "Bestsellers")} className={activeCatId == 1 ? "active" : ""}><img src="images/best-seller-dark.png" alt="" /><img src="images/best-seller-light.png" alt="" /><span>Bestsellers</span></li>
                    {!isDigitalMenu && <li onClick={() => handleSplCatClick(4, "Ordered Before")} className={activeCatId == 4 ? "active" : ""}><img src="images/ordered-before-dark.png" alt="" /><img src="images/ordered-before-light.png" alt="" /><span>Ordered Before</span></li>}

                    <li onClick={() => handleSplCatClick(2, "Today's Special")} className={activeCatId == 2 ? "active" : ""}><img src="images/today-special-dark.png" alt="" /><img src="images/today-special-light.png" alt="" /><span>Today's Special</span></li>
                    <li onClick={() => handleSplCatClick(3, "Chef's Special")} className={activeCatId == 3 ? "active" : ""}><img src="images/chef-special-dark.png" alt="" /><img src="images/chef-special-light.png" alt="" /><span>Chef's Special</span></li>
                </ul>
            </div>
            {!showSearchBox && <div className="filter-category-outer">
                <div className="container">
                    <div className="filter-category">
                        <ul>
                            {availableTags.indexOf("1") != -1 && <li className={tag.indexOf("1") !== -1 ? "active" : ""} onClick={() => handleInputChange(1)}>
                                <span>Veg</span>
                            </li>}
                            {availableTags.indexOf("2") != -1 && <li className={tag.indexOf("2") !== -1 ? "active" : ""} onClick={() => handleInputChange(2)}>
                                <span>Non Veg</span>
                            </li>}
                            {availableTags.indexOf("24") != -1 && <li className={tag.indexOf("24") !== -1 ? "active" : ""} onClick={() => handleInputChange(24)}>
                                <span>Egg</span>
                            </li>}
                            {availableTags.indexOf("56") != -1 && <li className={tag.indexOf("56") !== -1 ? "active" : ""} onClick={() => handleInputChange(56)}>
                                <span>Jain</span>
                            </li>}
                            {availableTags.indexOf("524") != -1 && <li className={tag.indexOf("524") !== -1 ? "active" : ""} onClick={() => handleInputChange(524)}>
                                <span>Bar</span>
                            </li>}
                        </ul>
                        <span onClick={toggle} className="search fa fa-search text-pink"></span>
                    </div>
                </div>
            </div>}
            {showSearchBox && <div className="filter-category">
                <input ref={inputEl} type="text" className="form-input" placeholder="Search Food Item" value={searchText} onChange={handleSearchChange} />
                <span onClick={toggle} className="search  fa fa-times text-pink"></span>
            </div>}
        </>
    )
}

const mapStateToProps = state => {
    return {
        isLoaded: state.restaurant.isLoaded,
        availableTags: getAvailableTags(state),
        merchantId: state.restaurant.merchant_id,

    };

}


export default connect(mapStateToProps, { loadSpecialCategory, filter })(Filter)
